import React from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import styles from './header.module.css';
import Logo from "../logo/logo";
import { ReactComponent as Cart } from "../../images/cart.svg";
import { ReactComponent as Star } from "../../images/star_to_stroke.svg";
import SearchForm from "../search_form/search_form";
import Navbar from "../navbar/navbar";
import Tel from "../../images/tel_color4.svg";
import { SHOP_NAME } from "../../utils/constants";
import { useSelector, useDispatch } from "react-redux";
import { LOGOUT } from "../../services/actions/user_actions";
import { RESET_CUSTOMER } from "../../services/actions/customer_actions";
import { deleteAllCookies } from "../../utils/cookie";
import { CLEAR_PROFILE_FORM } from "../../services/actions/profile_form_actions";
import { getUser, getPhones, getSettings, getPathParams, getCart, getFavorites } from "../../services/selectors";
import Breadcrumbs from "../bread_crumbs/bread_crumbs";
import { CLEAR_CART } from "../../services/actions/cart_actions";
import { getProductsThunk } from "../../services/actions/products_actions";
import { RESET_FIRMS } from "../../services/actions/firms_actions";
import { CLEAR_ORDERS } from "../../services/actions/orders_actions";
import { CLEAR_FAV } from "../../services/actions/fav_actions";
import { RESET_FIND_USER_INPUT } from "../../services/actions/find_user_actions";


function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const user = useSelector(getUser);
  const phones = useSelector(getPhones);
  const settings = useSelector(getSettings);
  const countProductsInCart = useSelector(getCart).productsCount;
  const { count: countProductsInFav } = useSelector(getFavorites);
  const { uid } = useSelector(getPathParams);

  const handleLogout = () => {
    dispatch({ type: LOGOUT });
    dispatch({ type: RESET_CUSTOMER });
    dispatch({ type: RESET_FIRMS });
    dispatch({ type: CLEAR_ORDERS });
    dispatch({ type: CLEAR_FAV });
    dispatch({ type: RESET_FIND_USER_INPUT });
    dispatch(getProductsThunk('', ''));
    dispatch({ type: CLEAR_PROFILE_FORM });
    dispatch({ type: CLEAR_CART });
    navigate('/', { replace: true });
    deleteAllCookies();
  }

  return (
    <header className={styles.header}>
      <div className={`${styles.upper_block}`}>
        <Logo />
        <div className={`${styles.login_container}`}>
          {(!user.loggedIn) &&
            <>
            <NavLink
              to='/login'
              className={
                ({ isActive, isPending }) =>
                  isPending ? `${styles.login_link}` :
                    isActive ? `${styles.login_link_active}` :
                      `${styles.login_link}`
              }
            >Войти</NavLink>
              <NavLink
                to='/register'
                className={
                  ({ isActive, isPending }) =>
                    isPending ? `${styles.login_link}` :
                      isActive ? `${styles.login_link_active}` :
                        `${styles.login_link}`
                }
              >Регистрация</NavLink>
            </>
          }
          {user.loggedIn && user.is_active &&
            <>
              <NavLink to='/messages'
                className={
                  ({ isActive, isPending }) =>
                    isPending ? `${styles.login_link}` :
                      isActive ? `${styles.login_link_active}` :
                        `${styles.login_link}`
                }
              >Сообщения</NavLink>
              <NavLink to='/orders'
                className={
                  ({ isActive, isPending }) =>
                    isPending ? `${styles.login_link}` :
                      isActive ? `${styles.login_link_active}` :
                        `${styles.login_link}`
                }
              >Заказы</NavLink>
              <NavLink
                to='/profile/me'
                className={
                  ({ isActive, isPending }) =>
                    isPending ? `${styles.login_link}` :
                      isActive ? `${styles.login_link_active}` :
                        `${styles.login_link}`
                }
              >Аккаунт</NavLink>
            </>
          }
          {user.loggedIn &&
            <button
              className={`${styles.login_button}`}
              onClick={handleLogout}
            >
              Выйти
            </button>
          }
        </div>
      </div>
      <div className={`${styles.medium_block}`}>
        <h2 className={`${styles.name}`}>
          {settings.shop_name || SHOP_NAME}
        </h2>
        <div className={`${styles.find_tel_links_container}`}>
          <SearchForm />
        </div>
        <div className={`${styles.telContainer}`}>
          <img alt="телефон" src={Tel} className={`${styles.telImg}`} />
          <p className={`${styles.telNum}`}>
            {phones.length > 0 && phones[0]['num']}
          </p>
        </div>
        <nav className={`${styles.linksContainer}`}>
          <Link
            to="/favorite"
            className={`${styles.linkWishList} ${!user.is_active && styles.navLinkDisable}`}
          >
            <Star className={`${styles.icon} ${location.pathname !== '/favorite' && styles.icon__noactive}`} />
            {user.loggedIn && user.is_active && countProductsInFav > 0 &&
              <p className={`${location.pathname === '/favorite' ? styles.countCircle : styles.countCircle__noactive}`}>
                {countProductsInFav}
              </p>
            }
          </Link>

          <Link
            to="/cart"
            className={`${styles.linkCartList}`}
          >
            <Cart className={`${styles.icon} ${location.pathname !== '/cart' && styles.icon__noactive}`} />
            {countProductsInCart > 0 &&
              <p className={`${location.pathname === '/cart' ? styles.countCircle : styles.countCircle__noactive}`}>
                {countProductsInCart}
              </p>
            }
          </Link>
        </nav>
      </div>
      <div className={styles.lowerBlock}>
        <Navbar />
        {location.pathname !== '/' && <Breadcrumbs onlyEnd={uid} />}
      </div>
    </header>
  );
}

export default Header;
